import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Factory that produces an `onRenderLabel` function for Fluent UI
 * components (IE: TextField) with a `instructions` inserted between the
 * label and the field itself.
 */
export const onRenderLabelWithInstructions = (instructions) => (props, defaultRender) => {
    return (_jsxs("div", { children: [_jsx("div", { children: defaultRender === null || defaultRender === void 0 ? void 0 : defaultRender(props) }), _jsx("div", { children: instructions })] }));
};
